import React, { Fragment } from 'react';

import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import classNames from 'classnames';
import PriceSpan from 'common/components/formatters/PriceSpan';
import { TranslatedMessage } from 'common/components/Intl';
import PurchaseOptionsTooltip from 'components/PurchaseOptionsTooltip';

import RadioButtonGroup from 'components/Form/RadioButtonGroup';
import AddToCartButton from '../containers/AddToCartButton';
import VariantPendingQuantityInput from '../containers/VariantPendingQuantityInput';

import QuickShopSubscriberModal from 'components/QuickShopSubscriberModal';

export default class QuickShopDualCTA extends React.Component {
  static propTypes = {
    canBecomeMember: propTypes.bool.isRequired,
    changeOrderMembership: propTypes.func.isRequired,
    changeSubscribingStatus: propTypes.func.isRequired,
    closeQuickShopModal: propTypes.func,
    currentOrder: accountPropTypes.OrderWithLineItems.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    productDisplayPage: propTypes.bool.isRequired,
    selectedVariant: accountPropTypes.ProductVariant,
  };

  constructor(props) {
    super(props);
    this.state = {
      purchaseType: 'subscribe',
      shouldOpenSubscriberModal: false,
    };
  }

  componentDidMount() {
    this.props.changeSubscribingStatus(this.state.purchaseType === 'subscribe');
  }

  componentDidUpdate(prevProps) {
    let purchaseType;
    const { changeSubscribingStatus, selectedVariant } = this.props;
    if (selectedVariant !== prevProps.selectedVariant) {
      if (selectedVariant.podCount === 2) {
        purchaseType = 'onetime';
      } else if (this.props.isMembershipOrder) {
        purchaseType = 'subscribe';
      }
      this.setState({ purchaseType });
    }

    changeSubscribingStatus(this.state.purchaseType === 'subscribe');
  }

  handleChange = event => {
    this.setState({
      purchaseType: event.target.value,
    });
  };

  radioButtonProps = () => {
    const { isMembershipOrder, selectedVariant } = this.props;
    const price = <PriceSpan amount={selectedVariant.price} />;
    const autoshipLabel = (
      <div className="quick-shop__autoship-label__text">
        <TranslatedMessage
          id="common.generic.auto_ship"
          className="heading--small"
        />
        <TranslatedMessage
          id="cart.quick_shop.dual_cta.best_offer"
          className="quick-shop__autoship-label__banner text--button"
        />
      </div>
    );

    const isTwoPack = () => selectedVariant.podCount === 2;

    const isChecked = () => {
      if (isTwoPack()) return false;
      return isMembershipOrder || this.isSubscribing();
    };

    const autoshipSubText = (
      <div>
        <TranslatedMessage
          id="cart.quick_shop.dual_cta.perks"
          className="quick-shop__autoship-label__sub-text"
        />
      </div>
    );

    return [
      {
        value: 'subscribe',
        text: autoshipLabel,
        subText: autoshipSubText,
        labelClass: 'quick-shop__autoship-label',
        badge: price,
        checked: isChecked(),
        disabled: isTwoPack(),
      },
      {
        value: 'onetime',
        text: (
          <TranslatedMessage
            id="cart.quick_shop.dual_cta.one_time_purchase"
            className="heading--small"
          />
        ),
        badge: price,
        disabled: isTwoPack() ? false : isMembershipOrder,
        checked: this.isOneTime(),
      },
    ];
  };

  isSubscribing = () => {
    return this.state.purchaseType === 'subscribe';
  };

  isOneTime = () => {
    return this.state.purchaseType === 'onetime';
  };

  subscribeText = () => {
    if (this.isSubscribing()) {
      return 'Subscribe';
    }
  };

  openSubscriberModal = () => {
    this.setState({
      shouldOpenSubscriberModal: true,
    });
  };

  closeSubscriberModal = () => {
    this.setState({
      shouldOpenSubscriberModal: false,
      purchaseType: 'onetime',
    });
  };

  attemptCloseQuickShopModal = () => {
    const { closeQuickShopModal } = this.props;

    closeQuickShopModal && closeQuickShopModal();
  };

  addToCartAndSubscribe = () => {
    this.isSubscribing()
      ? this.handleSubscribing()
      : this.attemptCloseQuickShopModal();
  };

  handleSubscribing = () => {
    const { canBecomeMember, changeOrderMembership } = this.props;

    if (canBecomeMember) {
      changeOrderMembership(true, 'cart-autoship-cta');
      this.attemptCloseQuickShopModal();
    } else {
      this.openSubscriberModal(true);
    }
  };

  render() {
    const { selectedVariant, currentOrder, productDisplayPage } = this.props;
    const { shouldOpenSubscriberModal } = this.state;

    return (
      <Fragment>
        <QuickShopSubscriberModal
          isOpen={shouldOpenSubscriberModal}
          onClose={this.closeSubscriberModal}
        />
        <div className="quick-shop__purchase-options">
          <PurchaseOptionsTooltip />
          <RadioButtonGroup
            name="quick-shop-purchase-options"
            radioButtonProps={this.radioButtonProps()}
            onChange={this.handleChange}
          />
        </div>
        <div className="variant-actions-form__quantity-and-cta">
          <VariantPendingQuantityInput
            order={currentOrder}
            variant={selectedVariant}
            defaultQuantity={1}
            className={'variant-actions-form__quantity__input'}
            offeringId={selectedVariant.offeringId}
          />

          <AddToCartButton
            className={classNames('variant-actions-form__button', {
              'variant-actions-form__button--quick-shop-modal': !productDisplayPage,
              subscribe: this.isSubscribing(),
            })}
            sku={selectedVariant.sku}
            isSubscriberExclusive={selectedVariant.subscriberExclusive}
            onClick={this.addToCartAndSubscribe}
            isSoldOut={selectedVariant.isSoldOut}
            offeringId={selectedVariant.offeringId}
            text={this.subscribeText()}
          />
        </div>
      </Fragment>
    );
  }
}
